import React, { } from 'react';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useEffect } from 'react';
import { useCallback } from 'react';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');


export default function ObjectVtpDescription(props) {
    const { object: instance, extend, inline, style, className, alt, fontSize, fontWeight } = props;
    // useEffect(() => {

    // }, [item])
    const getInstance = useCallback((inst) => {
        return (alt) ? alt : inst;
    }, [alt])

    return (
        <div className={className} style={style}>
            {instance &&
                <div>
                    {!inline && <div style={{ display: "flex", flexDirection: "column" }}>
                        {instance?.meropriyatieID && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.meropriyatie)?.nazvanieMeropriyatiya}</span> - {dayjs(getInstance(instance?.meropriyatie)?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(getInstance(instance?.meropriyatie)?.mestoProvedeniya) ? "(" + getInstance(instance?.meropriyatie)?.mestoProvedeniya?.name + ")" : ""}
                        </div>}
                        {instance?.regionalnoeOtdelenieID && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.regionalnoeOtdelenie)?.nazvanie}</span>
                        </div>}
                        {instance?.shkolaID && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.shkola)?.nazvanieShkoliTantsev}</span>, <span>{getInstance(instance?.shkola)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </div>}

                        {(instance?.chlenFederatsiiID && getInstance(instance?.chlenFederatsii)?.regionalnoeOtdelenie) && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.chlenFederatsii)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </div>}

                        {instance?.kollektivID && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.kollektiv)?.nazvanieKollektiva}</span>
                            {getInstance(instance?.kollektiv)?.regionalnoeOtdelenie && <span>, {getInstance(instance?.kollektiv)?.regionalnoeOtdelenie?.nazvanie}</span>}
                            {getInstance(instance?.kollektiv)?.shkolaFederatsii && <span>, {getInstance(instance?.kollektiv)?.shkolaFederatsii?.nazvanieShkoliTantsev}</span>}
                        </div>}

                        {instance?.organizatorID && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.organizator)?.nazvanie}</span>
                            {getInstance(instance?.organizator)?.regionalnoeOtdelenie && <span>, {getInstance(instance?.organizator)?.regionalnoeOtdelenie?.nazvanie}</span>}
                        </div>}

                        {(instance?.prepodavatelID && !getInstance(instance?.prepodavatel)?.shkola && getInstance(instance?.prepodavatel)?.regionalnoeOtdelenie) && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.prepodavatel)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </div>}

                        {(instance?.prepodavatelID && getInstance(instance?.prepodavatel)?.shkola) && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.prepodavatel)?.shkola?.nazvanieShkoliTantsev}</span>
                        </div>}

                        {(instance?.sudyaID && getInstance(instance?.sudya)?.regionalnoeOtdelenie) && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.sudya)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </div>}
                        {(instance?.tantsorID && getInstance(instance?.tantsor)?.regionalnoeOtdelenie) && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.tantsor)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </div>}

                        {instance?.paraID && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                            <span>{getInstance(instance?.para)?.nazvanieKollektiva}</span>
                            {getInstance(instance?.para)?.regionalnoeOtdelenie && <span>, {getInstance(instance?.para)?.regionalnoeOtdelenie?.nazvanie}</span>}

                            {getInstance(instance?.para)?.para && <span>, {getInstance(instance?.para)?.para?.partner?.lastname} - {getInstance(instance?.para)?.para?.partnersha.lastname}</span>}
                        </div>}

                    </div>}
                    {!!inline && <div style={{ fontSize: fontSize || "12px", fontWeight: fontWeight || "lighter" }}>
                        {instance?.meropriyatieID && <span>
                            <span>{getInstance(instance?.meropriyatie)?.nazvanieMeropriyatiya}</span> - {dayjs(getInstance(instance?.meropriyatie)?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(getInstance(instance?.meropriyatie)?.mestoProvedeniya) ? "(" + getInstance(instance?.meropriyatie)?.mestoProvedeniya?.name + ")" : ""}
                        </span>}
                        {instance?.regionalnoeOtdelenieID && <span>
                            <span>{getInstance(instance?.regionalnoeOtdelenie)?.nazvanie}</span>
                        </span>}
                        {instance?.shkolaID && <span>
                            <span>{getInstance(instance?.shkola)?.nazvanieShkoliTantsev}</span>
                        </span>}

                        {(instance?.chlenFederatsiiID && getInstance(instance?.chlenFederatsii)?.regionalnoeOtdelenie) && <span>
                            <span>{getInstance(instance?.chlenFederatsii)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </span>}

                        {instance?.kollektivID && <span>
                            <span>{getInstance(instance?.kollektiv)?.nazvanieKollektiva}</span>
                            {getInstance(instance?.kollektiv)?.regionalnoeOtdelenie && <span>, {getInstance(instance?.kollektiv)?.regionalnoeOtdelenie?.nazvanie}</span>}
                            {getInstance(instance?.kollektiv)?.shkolaFederatsii && <span>, {getInstance(instance?.kollektiv)?.shkolaFederatsii?.nazvanieShkoliTantsev}</span>}
                        </span>}

                        {instance?.organizatorID && <span>
                            <span>{getInstance(instance?.organizator)?.nazvanie}</span>
                            {getInstance(instance?.organizator)?.regionalnoeOtdelenie && <span>, {getInstance(instance?.organizator)?.regionalnoeOtdelenie?.nazvanie}</span>}
                        </span>}

                        {(instance?.prepodavatelID && !getInstance(instance?.prepodavatel)?.shkola && getInstance(instance?.prepodavatel)?.regionalnoeOtdelenie) && <span>
                            <span>{getInstance(instance?.prepodavatel)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </span>}

                        {(instance?.prepodavatelID && getInstance(instance?.prepodavatel)?.shkola) && <span>
                            <span>{getInstance(instance?.prepodavatel)?.shkola?.nazvanieShkoliTantsev}</span>
                        </span>}

                        {(instance?.sudyaID && getInstance(instance?.sudya)?.regionalnoeOtdelenie) && <span>
                            <span>{getInstance(instance?.sudya)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </span>}
                        {(instance?.tantsorID && getInstance(instance?.tantsor)?.regionalnoeOtdelenie) && <span>
                            <span>{getInstance(instance?.tantsor)?.regionalnoeOtdelenie?.nazvanie}</span>
                        </span>}

                        {instance?.paraID && <span>
                            <span>{getInstance(instance?.para)?.nazvanieKollektiva}</span>
                            {getInstance(instance?.para)?.regionalnoeOtdelenie && <span>, {getInstance(instance?.para)?.regionalnoeOtdelenie?.nazvanie}</span>}

                            {getInstance(instance?.para)?.para && <span>, {getInstance(instance?.para)?.para?.partner?.lastname} - {getInstance(instance?.para)?.para?.partnersha.lastname}</span>}
                        </span>}


                    </div>}
                </div>
            }
            {extend && extend()}
        </div>
    )
}

export function ObjectVtpDescriptionString(instance, alt) {
     const getInstance = (inst) => {
        return (alt) ? alt : inst;
    }
    if (instance?.meropriyatieID) {
        return (`${getInstance(instance?.meropriyatie)?.nazvanieMeropriyatiya} - ${dayjs(getInstance(instance?.meropriyatie)?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(getInstance(instance?.meropriyatie)?.mestoProvedeniya) ? "(" + getInstance(instance?.meropriyatie)?.mestoProvedeniya?.name + ")" : ""}`)
    }
    if (instance?.regionalnoeOtdelenieID) {
        return (`${getInstance(instance?.regionalnoeOtdelenie)?.nazvanie}`)
    }
    if (instance?.shkolaID) {
        return (`${getInstance(instance?.shkola)?.nazvanieShkoliTantsev}, ${getInstance(instance?.shkola)?.regionalnoeOtdelenie?.nazvanie}`)
    }

    if (instance?.chlenFederatsiiID && getInstance(instance?.chlenFederatsii)?.regionalnoeOtdelenie) {
        return (`${getInstance(instance?.chlenFederatsii)?.regionalnoeOtdelenie?.nazvanie}`)
    }

    if (instance?.kollektivID) {
        return (`${getInstance(instance?.kollektiv)?.nazvanieKollektiva} ${(getInstance(instance?.kollektiv)?.regionalnoeOtdelenie)? getInstance(instance?.kollektiv)?.regionalnoeOtdelenie?.nazvanie:""} ${(getInstance(instance?.kollektiv)?.shkolaFederatsii)? getInstance(instance?.kollektiv)?.shkolaFederatsii?.nazvanieShkoliTantsev:""}`)
    }

    if (instance?.organizatorID) {
        return (`${getInstance(instance?.organizator)?.nazvanie} ${(getInstance(instance?.organizator)?.regionalnoeOtdelenie)? getInstance(instance?.organizator)?.regionalnoeOtdelenie?.nazvanie:""}`)
    }

    if (instance?.prepodavatelID && !getInstance(instance?.prepodavatel)?.shkola && getInstance(instance?.prepodavatel)?.regionalnoeOtdelenie) {
        return (`${getInstance(instance?.prepodavatel)?.regionalnoeOtdelenie?.nazvanie}`)
    }

    if (instance?.prepodavatelID && getInstance(instance?.prepodavatel)?.shkola) {
        return (`${getInstance(instance?.prepodavatel)?.shkola?.nazvanieShkoliTantsev}`)
    }

    if (instance?.sudyaID && getInstance(instance?.sudya)?.regionalnoeOtdelenie) {
        return (`${getInstance(instance?.sudya)?.regionalnoeOtdelenie?.nazvanie}`)
    }
    if (instance?.tantsorID && getInstance(instance?.tantsor)?.regionalnoeOtdelenie) {
        return (`${getInstance(instance?.tantsor)?.regionalnoeOtdelenie?.nazvanie}`)
    }

    if (instance?.paraID) {
        return (`${getInstance(instance?.para)?.nazvanieKollektiva} ${(getInstance(instance?.para)?.regionalnoeOtdelenie)? ", " + getInstance(instance?.para)?.regionalnoeOtdelenie?.nazvanie:""} ${(getInstance(instance?.para)?.para)? ", "+getInstance(instance?.para)?.para?.partner?.lastname+" - "+getInstance(instance?.para)?.para?.partnersha.lastname:""}`)
    }

}
